<div>
  <ng-container gstarContainer />
</div>
